import { t } from "./localization";

export const LocalizedFileFilter = (key: string, extensions: string[]) => {
  return [{
    get name() {
      return t(key);
    },
    extensions
  }];
};

export const getCombinedExtension = (key, filters) => {
  let extensions = [];
  filters.forEach(filter => {
    if (!filter) return;
    filter.forEach(x => {
      extensions = [...extensions, ...x.extensions];
    });
  });

  return [{
    get name() {
      return t(key);
    },
    extensions
  }];
};

export const lasFileFormat = "las";
export const encompassFileFormat = "idx";
export const e57FileFormat = "e57";
export const potreeFileFormat = "bin";
export const pngFileFormat = 'png';

export const pngFilter = LocalizedFileFilter(
  'dialog.extension-image-files-png', [pngFileFormat]);

export const pointCloudFileFormats = [lasFileFormat,
  encompassFileFormat, e57FileFormat, potreeFileFormat];

export const pointCloudFilter = LocalizedFileFilter(
  "dialog.extension-pointclouds", pointCloudFileFormats);

export const configFileType = "json";
export const configFilter = LocalizedFileFilter(
  "dialog.extension-project", [configFileType]);

export const customURLFileType = "json";
export const customURLFilter = LocalizedFileFilter(
  "dialog.custom-url", [customURLFileType]);

export const imageOrthoFormat = ['tif', 'tiff'];
export const imageOrthoFilter = LocalizedFileFilter(
  "dialog.extension-ortho", imageOrthoFormat);

export const imageCSVFormat = ['csv', 'txt'];
export const imageCSVFilter = LocalizedFileFilter(
  "dialog.extension-images", imageCSVFormat);

export const projFileFormat = ['eprj'];

export const imagePlanarFormat = ['plnr'];
export const imagePlanarFilter = LocalizedFileFilter(
  "dialog.extension-planar", imagePlanarFormat);

export const csvExportFilter = LocalizedFileFilter(
  "dialog.extension-csv", ["csv"]);

export const cameraMatrixFilter = LocalizedFileFilter(
  "dialog.extension-4x4", ["4x4"]);

export const measureDataFormat = "3dm";
export const measureDataFilter = LocalizedFileFilter(
  "dialog.measure-data", [measureDataFormat]);

export const measureCSVFilter = LocalizedFileFilter(
  "dialog.measure-csv", ['csv']);

export const tagCSVFilter = LocalizedFileFilter(
  "dialog.tag-csv", ['csv']);

export const DXFFileFormat = "dxf";
export const SHPFileFormat = "shp";
export const IFCFileFormat = "ifc";
export const xmlFileFormat = "xml";
const zipExtension = "zip";

const drawingFormats = [DXFFileFormat, SHPFileFormat, zipExtension];

export const drawingFilter = LocalizedFileFilter(
  "dialog.drawing-files", drawingFormats);

export const IFCModelFilter = LocalizedFileFilter(
  "dialog.extension-ifc", [IFCFileFormat]);

export const DXFModelFilter = LocalizedFileFilter(
  "dialog.extension-dxf", [DXFFileFormat]);

export const SHPModelFilter = LocalizedFileFilter(
  "dialog.extension-shp", [SHPFileFormat]);

const modelFormats = [DXFFileFormat, SHPFileFormat, IFCFileFormat];

export const modelFileFilter = LocalizedFileFilter(
  "dialog.model-files", modelFormats);

const labelExtension = "3dl";
export const labelFilter = LocalizedFileFilter(
  "dialog.label-file", [labelExtension]);

const modelExtension = "pth";
export const modelFilter = LocalizedFileFilter(
  "dialog.model-file", [modelExtension]);

const xmlExtension = "xml";
export const xmlFileFilter = LocalizedFileFilter(
  "dialog.xml-file", [xmlExtension]);

export const lasFileFilter = LocalizedFileFilter(
  "dialog.extension-las", [lasFileFormat]
);
